module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-create-api.655e1465.png";